const poboxLabels = [
    {
        title: 'General Information',
        type: 'columns',
        fields: [
            { label: '[POBOXNUMBER]', description: 'pobox_number', visible: true }
        ]
    },
    {
        title: 'Shipper and Consignee',
        type: 'columns',
        fields: [
            {
                label: '[CONSIGNEE]',
                description: 'consignee_description',
                visible: true
            },
            { label: '[SHIPPER]', description: 'shipper_description', visible: true }
        ]
    },
    {
        title: 'Customer',
        type: 'columns',
        fields: [
            {
                label: '[NOMBRECLIENTE]',
                description: 'customer_name',
                visible: true
            },
            {
                label: '[APELLIDOCLIENTE]',
                description: 'customer_lastname',
                visible: true
            },
            {
                label: '[DIRECCIONCLIENTE]',
                description: 'customer_address',
                visible: true
            },
            {
                label: '[CIUDADCLIENTE]',
                description: 'customer_city',
                visible: true
            },
            {
                label: '[ESTADOCLIENTE]',
                description: 'customer_state',
                visible: true
            },
            {
                label: '[PAISCLIENTE]',
                description: 'customer_country',
                visible: true
            },
            {
                label: '[EMAILCLIENTE]',
                description: 'customer_email',
                visible: true
            },
            {
                label: '[MOVILCLIENTE]',
                description: 'customer_mobile',
                visible: true
            },
            {
                label: '[TELEFONOCLIENTE]',
                description: 'customer_phone',
                visible: true
            },
            {
                label: '[CASILLEROCLIENTE]',
                description: 'customer_pobox',
                visible: true
            }
        ]
    }
];

export default poboxLabels;
